import img1 from "../assets/gallery/K2k2026/K2K1.jpg";
import img2 from "../assets/gallery/K2k2026/K2K2.jpg";
import img3 from "../assets/gallery/K2k2026/K2K3.jpg";
import img4 from "../assets/gallery/K2k2026/K2K4.jpg";
import img5 from "../assets/gallery/K2k2026/K2K5.jpg";
import img6 from "../assets/gallery/K2k2026/K2K6.jpg";
import img7 from "../assets/gallery/K2k2026/K2K7.jpg";
import img8 from "../assets/gallery/K2k2026/K2K8.jpg";
import img9 from "../assets/gallery/K2k2026/K2K9.jpg";
import img10 from "../assets/gallery/K2k2026/K2K10.jpg";
import img11 from "../assets/gallery/K2k2026/K2K11.jpg";
import img12 from "../assets/gallery/K2k2026/K2K12.jpg";
import img13 from "../assets/gallery/K2k2026/K2K13.jpg";
import img14 from "../assets/gallery/K2k2026/K2K14.jpg";
import img15 from "../assets/gallery/K2k2026/K2K15.jpg";
import img16 from "../assets/gallery/K2k2026/K2K16.jpg";
import img17 from "../assets/gallery/K2k2026/K2K17.jpg";
import img18 from "../assets/gallery/K2k2026/K2K18.jpg";
import img19 from "../assets/gallery/K2k2026/K2K19.jpg";
import img20 from "../assets/gallery/K2k2026/K2K20.jpg";
import img21 from "../assets/gallery/K2k2026/K2K21.jpg";
import img22 from "../assets/gallery/K2k2026/K2K22.jpg";
import img23 from "../assets/gallery/K2k2026/K2K23.jpg";
import img24 from "../assets/gallery/K2k2026/K2K24.jpg";
import img25 from "../assets/gallery/K2k2026/K2K25.jpg";
import img26 from "../assets/gallery/K2k2026/K2K26.jpg";
import img27 from "../assets/gallery/K2k2026/K2K27.jpg";
import img28 from "../assets/gallery/K2k2026/K2K28.jpg";
import img29 from "../assets/gallery/K2k2026/K2K29.jpg";
import img30 from "../assets/gallery/K2k2026/K2K30.jpg";
import img31 from "../assets/gallery/K2k2026/K2K31.jpg";
import img32 from "../assets/gallery/K2k2026/K2K32.jpg";
import img33 from "../assets/gallery/K2k2026/K2K33.jpg";
import img34 from "../assets/gallery/K2k2026/K2K34.jpg";
import img35 from "../assets/gallery/K2k2026/K2K35.jpg";
import img36 from "../assets/gallery/K2k2026/K2K36.jpg";
import img37 from "../assets/gallery/K2k2026/K2K37.jpg";
import img38 from "../assets/gallery/K2k2026/K2K38.jpg";
import img39 from "../assets/gallery/K2k2026/K2K39.jpg";
import img40 from "../assets/gallery/K2k2026/K2K40.jpg";
import img41 from "../assets/gallery/K2k2026/K2K41.jpg";
import img42 from "../assets/gallery/K2k2026/K2K42.jpg";
import img43 from "../assets/gallery/K2k2026/K2K43.jpg";
import img44 from "../assets/gallery/K2k2026/K2K44.jpg";
import img45 from "../assets/gallery/K2k2026/K2K45.jpg";
import img46 from "../assets/gallery/K2k2026/K2K46.jpg";
import img47 from "../assets/gallery/K2k2026/K2K47.jpg";
import img48 from "../assets/gallery/K2k2026/K2K48.jpg";
import img49 from "../assets/gallery/K2k2026/K2K49.jpg";
import img50 from "../assets/gallery/K2k2026/K2K50.jpg";

const k2kGallery = [
  { img: img1, rowSpan: 2 },
  { img: img2 },
  { img: img3 },

  { img: img4, colSpan: 2 },

  { img: img5 },
  { img: img6 },
  { img: img7 },

  { img: img8 },
  { img: img9 },
  { img: img10, rowSpan: 2 },

  { img: img11 },
  { img: img12 },

  { img: img13, colSpan: 2 },

  { img: img14 },
  { img: img15 },
  { img: img16 },

  { img: img17 },
  { img: img18 },
  { img: img19 },

  { img: img20, rowSpan: 2 },
  { img: img21 },
  { img: img22 },

  { img: img23 },
  { img: img24, colSpan: 2 },

  { img: img25 },
  { img: img26 },
  { img: img27 },

  { img: img28 },
  { img: img29 },
  { img: img30 },

  { img: img31, rowSpan: 2 },
  { img: img32 },
  { img: img33 },

  { img: img34 },
  { img: img35, colSpan: 2 },

  { img: img36 },
  { img: img37 },
  { img: img38 },

  { img: img39 },
  { img: img40 },

  { img: img41 },
  { img: img42 },
  { img: img43 },

  { img: img44, rowSpan: 2 },
  { img: img45 },
  { img: img46 },

  { img: img47 },
  { img: img48 },
  { img: img49 },
  { img: img50 },
];

export default k2kGallery;
